import * as apiTypes from './types';
import formatISO from 'date-fns/formatISO';
import API from '@aws-amplify/api'
import { API_NAME } from '../const';
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

/**
 * 新着情報通知取得API
 */
export const fetchNotification = async (): Promise<apiTypes.FetchNotificationResponseData> => {
  await checkCurrentAuthenticatedUser()
  try {
    const res = await API.get(API_NAME, `/v2/notification`, {
      queryStringParameters: {
        created_at_from: formatISO(new Date()),
      },
    });
    return res;
  } catch (err) {
    throw new Error(err.message);
  }
};
